"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideBarListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _A = require("../../../../UI/A");
var _Icon = require("../../../../UI/Icon");
var _SideBar = _interopRequireDefault(require("../SideBar.styles"));
var _SideBar2 = require("../SideBar.labels");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SideBarListItem = function SideBarListItem(itemProps) {
  var getLabel = (0, _hooks.useLabels)({
    labels: _SideBar2.labels
  });
  var item = itemProps.item,
    _itemProps$isMoreMenu = itemProps.isMoreMenuItem,
    isMoreMenuItem = _itemProps$isMoreMenu === void 0 ? false : _itemProps$isMoreMenu,
    onItemClick = itemProps.onItemClick,
    _itemProps$expandOnHo = itemProps.expandOnHover,
    expandOnHover = _itemProps$expandOnHo === void 0 ? false : _itemProps$expandOnHo;
  var id = item.id,
    label = item.label,
    isSelected = item.isSelected,
    isNewItem = item.isNewItem,
    isMoreMenuItemOpen = item.isMoreMenuItemOpen,
    withTopSeparator = item.withTopSeparator,
    href = item.href,
    target = item.target,
    icon = item.icon,
    onClick = item.onClick,
    items = item.items;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var hasItems = items && items.length > 0;
  var _useState = (0, _react.useState)(isMoreMenuItemOpen !== undefined ? isMoreMenuItemOpen : true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var styles = (0, _SideBar.default)(expandOnHover, !!isSelected, isOpen, isMoreMenuItem, withTopSeparator);
  var toggleMenu = function toggleMenu(e) {
    e.preventDefault();
    !isMobileView && setIsOpen(function (isOpen) {
      return !isOpen;
    });
  };
  var handleOnClick = function handleOnClick(e) {
    if (hasItems) {
      toggleMenu(e);
    } else {
      onClick && onClick(e);
      onItemClick && onItemClick(e);
    }
  };
  var role = hasItems ? 'button' : undefined;
  var ariaControls = hasItems ? "cc-SideBar__menu__item__accordion-".concat(id) : undefined;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
    className: styles['cc-SideBar__menu__item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
      isBtnView: true,
      view: "alternate",
      color: "basic",
      size: isMobileView ? 'small' : 'large',
      shape: isMobileView && !isMoreMenuItem ? 'rectangle' : 'roundedRectangle',
      onClick: function onClick(e) {
        return handleOnClick(e);
      },
      to: href !== null && href !== void 0 ? href : '',
      target: target,
      id: id,
      role: role,
      ariaControls: ariaControls,
      ariaExpanded: hasItems && isOpen || undefined,
      customStyle: styles['cc-SideBar__menu__item__anchor'](),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-SideBar__menu__item__anchor-content'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-SideBar__menu__item__icon'],
          children: icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: icon
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-SideBar__menu__item__label'],
          children: label
        }), isNewItem && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-SideBar__menu__item__new-item'],
          children: getLabel('newItemLabel')
        }), hasItems && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-SideBar__menu__item__arrow'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "ArrowSidebar"
          })
        })]
      })
    }), hasItems && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "region",
      id: ariaControls,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: styles['cc-SideBar__menu__item__inner-list'],
        children: items.map(function (item, i) {
          var itemProps = {
            item: item,
            isMoreMenuItem: isMoreMenuItem,
            onItemClick: onItemClick
          };
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(SideBarListItem, _objectSpread({}, itemProps), i);
        })
      }, "ul-".concat(id))
    })]
  }, id);
};
exports.SideBarListItem = SideBarListItem;